(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/information-panels/information-panels.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/information-panels/information-panels.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const Icon = svs.ui.ReactIcon;
const useBreakpointGreaterThan = svs.ticket_partner.sharedComponents.hooks.useBreakpointGreaterThan;
const InformationPanels = _ref => {
  let articles = _ref.articles;
  const _useBreakpointGreater = useBreakpointGreaterThan('sm'),
    _useBreakpointGreater2 = _slicedToArray(_useBreakpointGreater, 1),
    greaterThan = _useBreakpointGreater2[0];
  const flexDirection = greaterThan ? 'u-flex-row' : 'u-flex-column';

  const colOrder = useMemo(() => {
    const cmsArticles = [...articles];
    if (articles.length === 1) {
      return [{
        col: [articles[0]],
        singleColumn: true
      }];
    }
    const middleIndex = Math.ceil(cmsArticles.length / 2);
    const deleteCount = Math.floor(cmsArticles.length / 2);
    const columnLeft = cmsArticles.splice(0, deleteCount);
    const columnRight = cmsArticles.splice(-middleIndex);
    return [{
      col: columnLeft
    }, {
      col: columnRight
    }];
  }, [articles]);
  const Columns = _ref2 => {
    let order = _ref2.order;
    return order.map((_ref3, i) => {
      let col = _ref3.col,
        _ref3$singleColumn = _ref3.singleColumn,
        singleColumn = _ref3$singleColumn === void 0 ? false : _ref3$singleColumn;
      return React.createElement(GridCol, {
        am: singleColumn ? 12 : 6,
        className: "u-flex u-flex-wrap",
        key: _.uniqueId(i),
        sm: 12
      }, col.map((article, i) => article && React.createElement(Card, {
        className: "margin-1 w100",
        key: _.uniqueId(i)
      }, React.createElement(CardBody, null, React.createElement("h2", {
        className: "u-flex card-title u-flex-justify-content-center"
      }, article.icon && React.createElement(Icon, {
        icon: article.icon,
        size: "500"
      }), "\xA0", React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: article.title
        }
      })), React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: article.body
        }
      })))));
    });
  };
  return articles.length ? React.createElement(GridRow, {
    className: "bg-tur-100 section-full-width padding-bottom-2 padding-top-2 margin-2",
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 6
    },
    xs: 12
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement("div", {
    className: "u-flex ".concat(flexDirection)
  }, React.createElement(Columns, {
    order: colOrder
  })))))) : React.createElement("div", null);
};
svs.ticket_partner.sharedComponents.informationPanels.InformationPanels = InformationPanels;

 })(window);